import api from './api';

const API_URL = '/api/event-types';

const DEFAULT_PAGE = 0;
const DEFAULT_SIZE = 100;

/**
 * Создать пользовательский тип события.
 */
export const createEventType = async (data) => {
  const response = await api.post(API_URL, data);
  return response.data;
};

/**
 * Получить список типов событий (пагинированный).
 */
export const listEventTypes = async (page = DEFAULT_PAGE, size = DEFAULT_SIZE) => {
  const response = await api.get(API_URL, { params: { page, size } });
  return response.data;
};

/**
 * Получить все типы событий (все страницы).
 */
export const listAllEventTypes = async () => {
  const firstPage = await listEventTypes(DEFAULT_PAGE, DEFAULT_SIZE);
  const totalPages = firstPage?.totalPages ?? 1;
  if (totalPages <= 1) {
    return firstPage?.content ?? [];
  }
  const pages = [firstPage];
  for (let p = 1; p < totalPages; p++) {
    pages.push(await listEventTypes(p, DEFAULT_SIZE));
  }
  return pages.flatMap((page) => page?.content ?? []);
};

/**
 * Получить тип события по ID.
 */
export const getEventType = async (id) => {
  const response = await api.get(`${API_URL}/${id}`);
  return response.data;
};

/**
 * Обновить пользовательский тип события.
 */
export const updateEventType = async (id, data) => {
  const response = await api.put(`${API_URL}/${id}`, data);
  return response.data;
};
